import { element$ } from './element';
import { ElementOptions } from './element.options';

type ElementType = HTMLButtonElement;
export type ButtonElementOptions = ElementOptions<ElementType> & {};
type Options = ButtonElementOptions;

export function button$(): ElementType;
export function button$(classes: string): ElementType;
export function button$(classes: string, children: Element[]): ElementType;
export function button$(classes: string, options: Options): ElementType;
export function button$(
  classes: string,
  options: Options,
  children: Element[]
): ElementType;
export function button$(children: Element[]): ElementType;
export function button$(options: Options): ElementType;
export function button$(options: Options, children: Element[]): ElementType;
export function button$(
  arg1?: Options | Element[] | string,
  arg2?: Options | Element[],
  arg3?: Element[]
): ElementType {
  return element$('button', arg1, arg2, arg3);
}
